module.exports = __webpack_public_path__ + "img/pr-5.ca9e454c.png";